/* eslint-disable jsx-a11y/label-has-associated-control */
/** @jsxImportSource @emotion/react */

import type { ChangeEventHandler } from "react";
import { useId } from "react";
import { switchButtonCSS } from "./Switch.css";
import type { SwitchBaseProps } from "./Switch.types";

export const SwitchBase = ({ isChecked, onChange, isDisabled }: SwitchBaseProps) => {
  const id = useId();

  const _onChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const { checked } = event.target;

    onChange?.(checked);
  };

  return (
    <>
      <input
        data-clay-blind
        type="checkbox"
        id={id}
        checked={isChecked}
        onChange={_onChange}
        disabled={isDisabled}
      />
      <label htmlFor={id} css={switchButtonCSS} />
    </>
  );
};
